import { RootState } from "../rootStore";

export const selectClinicList = ({ clinic }: RootState) => clinic.clinicList;

export const selectClinicUserList = ({ clinic }: RootState) =>
  clinic.clinicUserList;

export const selectClinicHasMore = ({ clinic }: RootState) => {
  return clinic.total > clinic.offset + clinic.limit;
};

export const selectSortConfig = ({ clinic }: RootState) => clinic.sortConfig;

export const selectLoading = ({ clinic }: RootState) => clinic.loading;
